import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const attendance = localStorage.getItem("attendance");

    if (attendance !== null) {
      navigate("/bdmtodo");  // Redirect to login page if not logged in
    }
  }, [navigate]);

  return <>{children}</>;
};

export default ProtectedRoute;
